import { WandaUserInfo } from "../types/PersonTypes";
import { IServiceUserInfo } from "../types/ServiceUserInfo";
import { RouteComponentProps } from "react-router-dom";

const navigateAddServiceUser = (
  serviceUsersList: IServiceUserInfo[] | WandaUserInfo[],
  careGiverPersonId: number,
  history: RouteComponentProps["history"],
  source: string
) => {
  const isCareGiverAdded = serviceUsersList.some(
    (info: IServiceUserInfo | WandaUserInfo) =>
      info.personId === careGiverPersonId
  );

  isCareGiverAdded
    ? history.push(`/DashBoard/AddServiceUser?source=${source}`)
    : history.push(`/DashBoard/AddServiceUser/Welcome?source=${source}`);
};

export default navigateAddServiceUser;
